<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="prologue">
<p class="ct"><a class="xref" href="#/ppptenlords005#toc">Prologue</a></p>
<p class="pf">‘A baroness? What lunatic would make you a baroness?’</p>
<p>‘I’ll have no aspersions cast on Her Majesty the Queen, my boy,’ said Jack Troutbeck, ‘especially now I’m about to become a pillar of the Establishment.’ The cackle that followed was so loud that even at a distance of 4,000 miles Amiss had to move the receiver away from his ear.</p>
<p>‘You know perfectly well what I mean. Which of your multifarious admirers decided that what the House of Lords really needed to liven it up was you?’</p>
<p>‘Mainly Bertie.’</p>
<p>‘Bertie?’</p>
<p>‘My God, you’ve got so slow since you’ve been in India, Robert. Been on the hippy trail, have you? Been losing your marbles at the feet of some guru while in quest of your inner being?’</p>
<p>‘It’s not just that you’re out of date, Jack, it’s that you revel in it. Hippies went out when I was in kindergarten. Rachel and I’ve been around half of India on the cultural—not the mystical—trail, since before Christmas. Which is, of course, why we missed this bizarre announcement in the New Year’s Honours List. Now, who’s Bertie?’</p>
<p>‘The Duke of Stormerod, of course, you idiot.’</p>
<p>‘You mean the Tory Party’s <i>éminence grise</i>?’</p>
<p>‘The very one.’</p>
<p>‘What’s he got to do with you?’</p>
<p>‘Gab, gab, gab. The purpose of this phone call is to tell you to come home and help me, not to give you my life story.’</p>
<p>‘Listen, you old villain, if you want to get me back to participate in some foul plan or other of yours, your only chance is to coax me. Railroading is out. So is being so fucking elliptical that you leave me in more of a fog than I was when this conversation started.’</p>
<p>‘Oh, very well then.’ Her sigh came through the ether like a March gale. ‘When Bertie was but Lord Bertie Whittingham-Sholto, heir to the dukedom, and was in the House of Commons, he was Minister for Central Planning. Do you follow that?’</p>
<p>‘I even remember that, Jack.’</p>
<p>‘I afforded him light relief.’</p>
<p>‘You were his moll?’</p>
<p>‘More his hitwoman. My job was to duff up those of my colleagues who were putting bureaucratic spikes in his radical wheels.’</p>
<p>‘It’s a pretty poor metaphor, if you don’t mind my saying so.’</p>
<p>She ignored him. ‘So now he’s in the Lords he wants me to do down the forces of evil.’</p>
<p>‘Which ones?’</p>
<p>‘Wets, trendies, enemies of England. You know—the usual lot.’</p>
<p>‘In the House of Lords?’</p>
<p>‘More there than you’d think, I’m sorry to say. That’s why I need you. They’re mustering for a dastardly attack on our heritage.’</p>
<p>‘Which bit?’</p>
<p>‘I’ll tell you when you get here.’</p>
<p>‘Why should I?’ Even to his own ears Amiss sounded petulant.</p>
<p>‘Because you’ll have fun.’</p>
<p>‘Fun? Last time we collaborated…’</p>
<p>‘Yes?’</p>
<p>‘…it involved death, disaster, trauma, temptation, capitulation, emotional upheaval, and general mayhem—all ending up in the triumph of Jack Troutbeck.’</p>
<p>‘Exactly,’ she trumpeted complacently. ‘It was fun.’</p>
<p>Amiss shrugged. ‘Well, while I’m job-hunting, I suppose I might be persuaded to help you out a bit. As long,’ he added hastily, ‘as what you’re at doesn’t offend my moral susceptibilities.’</p>
<p>‘Bugger your moral susceptibilities. When are you due back?’</p>
<p>‘In about two weeks.’</p>
<p>‘Ah, good timing. I’ll have done the palace by then, and you’ll be just in time for my introduction to my peers. You can help me carry my ermine. Twelve o’clock sharp, Tuesday fortnight, lobby of the House of Lords, best bib and tucker. We’ll have lunch first, and then you can watch me turn into a noblewoman. Further celebration that evening.’</p>
<p>‘It’s the day I get back, Jack, after an all-night, twelve-hour flight.’</p>
<p>The familiar words, ‘Don’t be such a wimp,’ were followed by, ‘Must fly. Enemies to swat. See you then.’</p>
<p>Slightly dazed but, despite himself, feeling a rush of adrenaline, Amiss rang Rachel’s office.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-tenlords007.vue?781dec2b